module.exports = __webpack_public_path__ + "img/bohetang.9616de26.png";